var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./IntegerInput.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9ebc5ad4\",\"hasScoped\":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./IntegerInput.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShopperProfile/FormComponents/IntegerInput.vue
// module id = 1065
// module chunks = 2